import { BooleanType } from '@convergence/types';
import { ActionInputProps } from './types';
import { ActionBoolInputSelector } from './type-selectors/bool-action-input-selector';
import { actionDataFromTreeAndPath } from './util';

export function AnalysisBoolAction(props: ActionInputProps<BooleanType>) {
  const actionData = actionDataFromTreeAndPath(
    props.tree,
    props.propertyPath
  ) ?? {
    type: 'value',
    value: false
  };

  return (
    <div>
      <label className="inline-flex items-center">
        {props.name}
        <ActionBoolInputSelector
          actionData={actionData}
          setActionData={(data) => {
            props.onChange(props.propertyPath, data);
          }}
        />
      </label>
    </div>
  );
}
